import axios from "axios";
import { ACTION_TYPES } from "./types";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { APP_STATUSES } from "../constants";
import Cookies from "js-cookie";

axios.defaults.baseURL = "https://cx.api.averly.com.na";

export const authenticateUser =
  ({ email, password }) =>
  async (dispatch) => {
    dispatch({ type: ACTION_TYPES.SET_AUTH_LOADING, payload: true });
    try {
      const res = await axios.post("/auth/authenticate", {
        email,
        password,
      });
      const userData = res.data;
      dispatch({ type: ACTION_TYPES.SET_USER_DATA, payload: userData });
      dispatch({
        type: ACTION_TYPES.UPDATE_APP_STATUS,
        payload: APP_STATUSES.LOGGED_IN,
      });
    } catch (err) {
      toast.error("Invalid Email or Password");
    }
    dispatch({ type: ACTION_TYPES.SET_AUTH_LOADING, payload: false });
  };

export const verifyToken = () => async (dispatch) => {
  dispatch({ type: ACTION_TYPES.SET_AUTH_LOADING, payload: true });
  const accessToken = Cookies.get("accessToken");
  try {
    const res = await axios.get("/auth/session-check", {
      headers: {
        Authorization: `Bearer ${String(accessToken)}`,
      },
    });
    dispatch({
      type: ACTION_TYPES.SET_USER_ID,
      payload: Cookies.get("userId"),
    });

    dispatch({ type: ACTION_TYPES.SET_ACCESS_TOKEN, payload: accessToken });

    dispatch({
      type: ACTION_TYPES.UPDATE_APP_STATUS,
      payload: APP_STATUSES.LOGGED_IN,
    });
  } catch (err) {
    dispatch({
      type: ACTION_TYPES.UPDATE_APP_STATUS,
      payload: APP_STATUSES.LOGGED_OUT,
    });

    window.location.replace(
      `https://auth.averly.com.na?origin=${window.location.href}`
    );
  }
  dispatch({ type: ACTION_TYPES.SET_AUTH_LOADING, payload: false });
};

export const getUserDetails =
  ({ userId }) =>
  async (dispatch) => {
    try {
      const res = await axios.get(`/iam/users?id=${userId}`);
      const userData = res.data;
      dispatch({ type: ACTION_TYPES.SET_USER_DATA, payload: userData[0] });
    } catch (err) {
      console.log(err);
    }
  };

export const updateAppStatus = (payload) => (dispatch) => {
  dispatch({
    type: ACTION_TYPES.UPDATE_APP_STATUS,
    payload,
  });
};

export const setUserData = (payload) => (dispatch) => {
  dispatch({
    type: ACTION_TYPES.SET_USER_DATA,
    payload,
  });
};
